import { ActionTypes } from "../constants/action-types";

export const setTheme = () => {
  return {
    type : ActionTypes.SET_THEME_ACTION,
  }
}